import Quote from '@uikit/components/Quote/Quote';
import SimpleQuote from '@uikit/components/SimpleQuote/SimpleQuote';
import type { MagazineQuoteWrapperProps } from './interfaces';

const MagazineQuoteWrapper = ({
  image,
  ...props
}: MagazineQuoteWrapperProps) => {
  if (image) {
    return <Quote {...props} image={image} quote={`<p>${props.quote}</p>`} />;
  }

  return <SimpleQuote {...props} />;
};

export default MagazineQuoteWrapper;
